/**
 * 학생 정보 및 상점/벌점 조회
 */
import React, { Component } from 'react';
import { udfAutoLogin, url, udfInlineLoading, udfNoneLoading, openAlert, openConfirm, udfGoHome } from '../../common/common';
import { lastCdInfo, udfSetStdtInfo, udfSetRuleInfo, udfSetTeacherInfo, stdtRule_reload, udfSetStdtRuleReload } from '../../common/usr/stdtList';
import { Navbar, ListGroup, Row, Col, Button, Badge, ButtonToolbar, ToggleButton, ToggleButtonGroup, Form } from 'react-bootstrap';
import $ from 'jquery';
import loader from '../../imgs/ajax-loader.gif';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleLeft, faPlusCircle, faPhone, faPen, faAngleUp, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import SideMenuCmp from './SideMenuCmp';
import { Link } from 'react-router-dom';
import { dropByCacheKey } from 'react-router-cache-route'

const noAuthMsg = '권한이 없습니다. 학교관리자에게 문의하여 주시기 바랍니다.';

const recordCountPerPage = 10;	// 한번에 불러 올 레코드 개수
let firstIndex = 0;	// 불러 올 시작 레코드
let isMore = true;	// 불러 올 레코드 존재 여부
let isRunning = false;
let isLogging = false;

let that = this;
let ntcTkInfo = null; // 알림톡 템플릿 정보

class StdtRuleHistoryCmp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // bootstrap Alert 변수
      alertShow: false,
      alertClickNo: null,
      alertClickYes: null,
      alertClickOk: null,
      alertMessage: null,

      // 상점 / 벌점
      ruleInfo: {},

      STD_CD: props.match.params.stdCd,
      ruleList: [],
      stdtInfo: {},
      RATING_GU_NM: '',
      ratingResult: {},
      MSG_YN: null,
      teacherInfo: {},

      sendNoList: [],
      SEND_NO: '',
      COIN: 0,

      usrInfo: null,
      clGuNm: { B: '상점', R: '벌점', G: '회복', S: '차감' },
    }

    props.cacheLifecycles.didCache(this.componentDidCache)
    props.cacheLifecycles.didRecover(this.componentDidRecover)
  }

  // 스크롤 위치 기억
  scrollPostion = 0;

  // 본 페이지를 떠날때 캐시 저장후 이벤트
  componentDidCache = () => {
    // 케시된 페이지 DROP
    dropByCacheKey('noticeCachce');
    dropByCacheKey('qnaCachce');
    dropByCacheKey('newsCachce');
    dropByCacheKey('ruleRptCachce');
    dropByCacheKey('ruleHistoryCachce');

    // 스크롤 이벤트 해제
    window.removeEventListener('scroll', this.handleScroll);
  }

  // 케시된 페이지로 바로 다시 돌아 왔을때 캐시 내용 복원 후 이벤트
  componentDidRecover = () => {
    // 케시된 페이지 DROP
    dropByCacheKey('noticeCachce');
    dropByCacheKey('qnaCachce');
    dropByCacheKey('newsCachce');
    dropByCacheKey('stdtListCachce');
    dropByCacheKey('ruleRptCachce');
    dropByCacheKey('ruleHistoryCachce');
    dropByCacheKey('stdtRuleHistoryCachce');

    // 스크롤 이벤트 바인딩
    window.addEventListener('scroll', this.handleScroll);

    if (stdtRule_reload) {
      this.udfSelectStdtRuleHistory('Y');
    } else {
      // 스크롤 위치 복원
      $(window).scrollTop(this.scrollPostion);
    }
  }

  componentWillReceiveProps = (props) => {
    if (props.match)
      this.setState({
        STD_CD: props.match.params.stdCd
      });
  }

  componentDidMount = () => {
    if (!isRunning && !isLogging) {
      isLogging = true;
      udfAutoLogin(this).then((data) => {
        isRunning = false;
        isLogging = false;
        if (data !== null && data.userSe === 'STDT') {
          this.props.history.push('/stdt/ruleList');
        } else if (data !== null && data.userSe === 'USR') {
          this.setState({ ...this.state, usrInfo: data, clGuNm: { B: data.BLUE_NM, R: data.RED_NM, G: '회복', S: '차감' } });
          this.udfSelectStdtRuleHistory('Y');
        } else {
          this.props.history.push('/');
        }
      });
    }

    if (this.state.ruleList.length === 0) {
      isMore = true;
      isRunning = false;
      firstIndex = 0;
    }

    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    // 스크롤 위치 기억
    this.scrollPostion = $(window).scrollTop();

    if ($('.wrap-loading').length - $('.wrap-loading.d-none').length !== 0)
      return false;

    let marginBottom = 71;
    if (window.innerHeight + marginBottom >= Math.ceil(document.getElementsByTagName('body')[0].getBoundingClientRect().bottom) && isMore) {
      this.udfSelectStdtRuleHistory('N');
    }
  }

  udfSelectStdtRuleHistory = (clearYn) => {
    if (!this.state.usrInfo || isLogging) return;
    that = this;

    if (this.state.STD_CD === undefined) {
      openAlert(this, '오류가 발생했습니다. 다시 시도해주세요.');
      this.props.history.go(-1);
      return;
    }

    if (clearYn === 'Y') {
      firstIndex = 0;
      isMore = true;
      $(window).scrollTop(0);
    }

    if (isMore && !isRunning) {
      udfInlineLoading();
      isRunning = true;

      $.ajax({
        url: url + '/sli/rule/selectRuleHistoryJSON.do',
        type: 'GET',
        dataType: 'jsonp',
        data: {
          isMobile: 'Y',
          SF_STD_CD: this.state.STD_CD,
          firstIndex: firstIndex,
          recordCountPerPage: recordCountPerPage
        },
        success: function (data) {
          udfNoneLoading();

          if (!data.success)
            that.componentDidMount();
          else {
            // init
            let ruleList = [];
            let stdtInfo = {};
            let ratingResult = {};
            let teacherInfo = {};
            let auth_yn = ''; // 권한
            ntcTkInfo = null;

            if (ntcTkInfo === null) ntcTkInfo = data.ntcTkInfo;

            ratingResult = {
              PREV_POINT: data.ratingResult[0].PREV_POINT,
              POINT_B: data.ratingResult[0].POINT_B,
              POINT_G: data.ratingResult[0].POINT_G,
              POINT_R: data.ratingResult[0].POINT_R,
              POINT_S: data.ratingResult[0].POINT_S,
              POINT_RATING: data.ratingResult[0].POINT_RATING,
            };

            if (data.user.BP_U_YN === 'Y') {
              if (data.user.BP_I_YN === 'Y') {
                auth_yn += that.state.usrInfo.BLUE_NM + ' 추가/수정, ';
              } else auth_yn += that.state.usrInfo.BLUE_NM + ' 수정, ';
            } else {
              if (data.user.BP_I_YN === 'Y') auth_yn += that.state.usrInfo.BLUE_NM + ' 추가, ';
            }

            if (data.user.RP_U_YN === 'Y') {
              if (data.user.RP_I_YN === 'Y') {
                auth_yn += that.state.usrInfo.RED_NM + ' 추가/수정';
              } else auth_yn += that.state.usrInfo.RED_NM + ' 수정';
            } else {
              if (data.user.RP_I_YN === 'Y') auth_yn += that.state.usrInfo.RED_NM + ' 추가';
            }

            teacherInfo = {
              ESNTL_GU: data.user.ESNTL_GU,
              BP_I_YN: data.user.BP_I_YN,
              BP_U_YN: data.user.BP_U_YN,
              RP_I_YN: data.user.RP_I_YN,
              RP_U_YN: data.user.RP_U_YN,
              JG_I_YN: data.user.JG_I_YN,
              JG_U_YN: data.user.JG_U_YN,
              HAKGWA: data.user.HAKGWA,
              GRADE: data.user.GRADE,
              BAN: data.user.BAN,
              name: data.user.name,
              uniqId: data.user.uniqId,
              auth_yn: auth_yn
            };

            stdtInfo = {
              BAN: data.stdtInfo[0].BAN,
              BUN: data.stdtInfo[0].BUN,
              GRADE: data.stdtInfo[0].GRADE,
              HAKGWA: data.stdtInfo[0].HAKGWA === undefined ? '' : data.stdtInfo[0].HAKGWA,
              STD_CD: data.stdtInfo[0].STD_CD,
              STD_NM: data.stdtInfo[0].STD_NM,
              HP_STD: data.stdtInfo[0].HP_STD === undefined ? '' : data.stdtInfo[0].HP_STD,
              HP_PRT: data.stdtInfo[0].HP_PRT === undefined ? '' : data.stdtInfo[0].HP_PRT,
              HP_PRT2: data.stdtInfo[0].HP_PRT2 === undefined ? '' : data.stdtInfo[0].HP_PRT2,
              STD_STATUS: data.stdtInfo[0].STD_STATUS,
              OTHER_CD: data.stdtInfo[0].OTHER_CD === undefined ? '' : data.stdtInfo[0].OTHER_CD,
              LAST_UPDATE: data.stdtInfo[0].LAST_UPDATE
            };

            if (data.resultList !== undefined && data.resultList !== null) {
              var idx = firstIndex;
              $.each(data.resultList, function (i, val) {
                idx++;

                ruleList.push({
                  CL_CD: val.CL_CD,
                  CL_GU: val.CL_GU,
                  CL_GU_NM: that.state.clGuNm[val.CL_GU],
                  CL_NM: val.CL_NM,
                  ESNTL_ID: val.ESNTL_ID,
                  ESNTL_NM: val.ESNTL_NM,
                  JG_DATE: val.JG_DATE,
                  JG_SEQ: val.JG_SEQ,
                  LAST_UPDATE: val.LAST_UPDATE,
                  POINT: val.POINT,
                  RL_CD: val.RL_CD,
                  RL_DATE: val.RL_DATE,
                  RL_TIME: val.RL_TIME,
                  I_RL_TIME: val.RL_TIME,
                  RL_DESC: val.RL_DESC,
                  RL_SEQ: val.RL_SEQ,
                  POINT_GU: that.state.clGuNm[val.CL_GU],
                  MSG_CNT: val.MSG_CNT,
                  MSG_PRNT_YN: val.MSG_PRNT_YN,
                  MSG_STDT_YN: val.MSG_STDT_YN,
                  MSG_CHRG_YN: val.MSG_CHRG_YN,
                  DEL_YN: val.DEL_YN,
                  MSG_YN: val.MSG_YN,
                  BATCH_YN: val.BATCH_YN,
                });
              });

              if (idx - firstIndex !== recordCountPerPage) isMore = false;
              firstIndex += recordCountPerPage;

              if (clearYn === 'N') ruleList = that.state.ruleList.concat(ruleList);

              // 조회한 학생 정보
              udfSetStdtInfo(stdtInfo);
              // 교사 정보
              udfSetTeacherInfo(teacherInfo);

              that.setState({
                stdtInfo: stdtInfo,
                ruleList: ruleList,
                RATING_GU_NM: data.RATING_GU_NM ? data.RATING_GU_NM.replace('평점(누계) = ', '').replace('회복점수', '회복').replace('지도차감점수', '차감') : "",
                ratingResult: ratingResult,
                MSG_YN: data.MSG_YN,
                teacherInfo: teacherInfo,
                sendNoList: data.sendNoList,
                SEND_NO: data.SEND_NO,
                COIN: data.COIN,
              });
            }
          }

          udfSetStdtRuleReload(false);
          isRunning = false;
        },
        error: function (jqXHR, status, error) {
          isRunning = false;
          that.componentDidMount();
          udfNoneLoading();
        }
      });
    }
  }

  // 삭제, 복구 modal
  fn_updateRuleDelYnAlert = (rlDate, rlSeq, msgCnt, delYn) => {
    let btn = "<label>"
      + "<input type=\"radio\" name=\"options\" id=\"sendMsgY\" value=\"Y\" onclick=\"document.getElementById('sendMsgError').style.display = 'none';\"> 발송"
      + "</label>"
      + "<label style=\"margin-left: 25px;\">"
      + "<input type=\"radio\" name=\"options\" id=\"sendMsgN\" value=\"N\" onclick=\"document.getElementById('sendMsgError').style.display = 'none';\"> 발송안함"
      + "</label>"
      + "<div id=\"sendMsgError\" style=\"display: none; width: 100%;\" class=\"alert alert-danger\">문자메시지 발송 여부를 선택해주세요.</div>";

    let msg = '삭제하시겠습니까? 삭제건은 평점 계산에서 제외됩니다.';
    if (delYn === 'N') {
      msg = '복구하시겠습니까? 해당 건 복구로 인한 중복 발생건이 존재할 수 있습니다.'
        + '<br>문자메시지를 발송하시겠습니까?<br>' + btn;
    } else {
      if (Number(msgCnt) > 0) {
        msg += '<br>삭제 대상건의 메시지 발송 이력이 존재합니다.<br><span style="color: red;">취소알림</span> 문자를 보내시겠습니까?<br>' + btn;
      }
    }

    msg = '<div style="line-height: 200%;">' + msg + '</div>';

    that = this;
    openConfirm(this, msg, function () { that.fn_updateRuleDelYn(rlDate, rlSeq, delYn); });
  }

  // 삭제, 복구
  fn_updateRuleDelYn = (rlDate, rlSeq, delYn) => {
    let sendMsgY = false;
    let sendMsgN = false;
    if (document.getElementById('sendMsgY') !== null && document.getElementById('sendMsgN') !== null) {
      sendMsgY = document.getElementById('sendMsgY').checked;
      sendMsgN = document.getElementById('sendMsgN').checked;

      if (!sendMsgY && !sendMsgN) {
        document.getElementById('sendMsgError').style.display = 'inline-block';
        return;
      }
    }

    // 알림톡 정보 매칭
    let ntcCd = '';
    let msg = '';
    if (sendMsgY) {
      ntcCd = ntcTkInfo['NTC_CD_' + (delYn === 'Y' ? 'C' : 'N')];
      msg = ntcTkInfo['FIX_TEMP_' + (delYn === 'Y' ? 'C' : 'N')];
    } else {
      ntcCd = '';
      msg = '';
    }

    let delErrMsg = '삭제 도중 오류가 발생했습니다. 다시 시도해주세요.';
    if (delYn === 'N') delErrMsg = '복구 도중 오류가 발생했습니다. 다시 시도해주세요.';

    if (!isRunning) {
      this.setState({
        alertShow: false
      });

      isRunning = true;
      udfInlineLoading();

      that = this;

      $.ajax({
        url: url + '/sli/rule/updateRuleDelYn.do',
        type: 'GET',
        dataType: 'jsonp',
        data: {
          isMobile: 'Y',
          STD_CD: that.state.stdtInfo.STD_CD,
          RL_DATE: rlDate,
          RL_SEQ: rlSeq,
          POINT: 0,
          DEL_YN: delYn,
          NTC_CD: ntcCd,
          MSG: msg,
          SEND_NO: that.state.SEND_NO,
        },
        success: function (data) {
          udfNoneLoading();
          isRunning = false;

          if (!data.success)
            openAlert(that, '접속이 끊겼습니다. 다시 로그인해 주십시오.', () => { udfGoHome(that) });
          else {
            if (data.result === 1) {
              that.udfSelectStdtRuleHistory('Y');
            } else {
              openAlert(that, delErrMsg);
            }
          }
        },
        error: function (jqXHR, status, error) {
          isRunning = false;
          udfNoneLoading();
          if (error.toString().indexOf('Error: jQuery') > -1 && error.toString().indexOf('was not called') > -1) {
            openAlert(that, '접속이 끊겼습니다. 다시 로그인해 주십시오.', () => { udfGoHome(that) });
          } else
            openAlert(that, delErrMsg);
          console.log('Request failed in StdtRuleHistory.js: ', jqXHR, status, error, jqXHR.responseText);
        }
      });
    }
  }

  // 메시지 전송 modal
  fn_sendMsgStdtRuleAlert = (rlDate, rlSeq) => {
    if (this.state.MSG_YN === 'N') {
      openAlert(this, '메시지 발송 권한이 없습니다.');
      return;
    }

    if (this.state.stdtInfo.HP_PRT === '' && this.state.stdtInfo.HP_PRT2 === '') {
      openAlert(this, '[발송불가] 학부모 휴대전화번호 미입력');
      return;
    }

    that = this;
    openConfirm(this, '메시지를 발송하시겠습니까?', function () { that.fn_sendMsgStdtRule(rlDate, rlSeq); });
  }

  // 메시지 전송
  fn_sendMsgStdtRule = (rlDate, rlSeq) => {
    if (!isRunning) {
      const msgErrMsg = '발송 실패! \n\n잠시 후 다시 시도해 주시기 바랍니다.';

      isRunning = true;
      that = this;

      $.ajax({
        url: url + '/sli/rule/sendMsgStdtRule.do',
        type: 'GET',
        dataType: 'jsonp',
        data: {
          isMobile: 'Y',
          STD_CD: that.state.stdtInfo.STD_CD,
          RL_DATE: rlDate,
          RL_SEQ: rlSeq,
          SEND_NO: that.state.SEND_NO,
        },
        success: function (data) {
          udfNoneLoading();
          isRunning = false;

          if (!data.success)
            openAlert(that, '접속이 끊겼습니다. 다시 로그인해 주십시오.', () => { udfGoHome(that) });
          else {
            if (data.result) {
              openAlert(that, '메시지가 발송되었습니다. 발송결과는 보낸 메시지 현황에서 확인해 주세요.');
              that.udfSelectStdtRuleHistory('Y');
            } else {
              openAlert(that, msgErrMsg);
            }
          }
        },
        error: function (jqXHR, status, error) {
          isRunning = false;
          udfNoneLoading();
          if (error.toString().indexOf('Error: jQuery') > -1 && error.toString().indexOf('was not called') > -1) {
            openAlert(that, '접속이 끊겼습니다. 다시 로그인해 주십시오.', () => { udfGoHome(that) });
          } else
            openAlert(that, msgErrMsg);
          console.log('Request failed in StdtRuleHistory.js: ', jqXHR, status, error, jqXHR.responseText);
        }
      });
    }
  }

  udfSetEmptyRuleInfo = () => {
    const today = new Date();
    const data = {
      POINT_GU: lastCdInfo.POINT_GU ? lastCdInfo.POINT_GU : '',
      RL_DATE: lastCdInfo.RL_DATE ? lastCdInfo.RL_DATE : today.getFullYear() + '-' + (Number(today.getMonth() + 1) < 10 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1)) + '-' + (Number(today.getDate()) < 10 ? '0' + today.getDate() : today.getDate()),
      RL_TIME: lastCdInfo.RL_TIME ? lastCdInfo.RL_TIME : '',
      RL_DESC: lastCdInfo.RL_DESC ? lastCdInfo.RL_DESC : '',
      ESNTL_NM: this.state.teacherInfo.name,
      ESNTL_ID: this.state.teacherInfo.uniqId,
      POINT: lastCdInfo.POINT ? lastCdInfo.POINT : '',
      MSG_CNT: 0,
      CL_CD: lastCdInfo.CL_CD ? lastCdInfo.CL_CD : '',
      RL_CD: lastCdInfo.RL_CD ? lastCdInfo.RL_CD : '',
      CL_GU: lastCdInfo.CL_GU ? lastCdInfo.CL_GU : '',
      SELF_YN: lastCdInfo.SELF_YN ? lastCdInfo.SELF_YN : '',
      ONLY_SELF_YN: lastCdInfo.ONLY_SELF_YN ? lastCdInfo.ONLY_SELF_YN : '',
      CL_GU_NM: lastCdInfo.CL_GU_NM ? lastCdInfo.CL_GU_NM : '',
      RL_SEQ: 0,

      sendNoList: this.state.sendNoList,
      SEND_NO: this.state.SEND_NO,
      COIN: this.state.COIN,

      NTC_CD: ntcTkInfo['NTC_CD_N'],
      MSG: ntcTkInfo['FIX_TEMP_N'],
    };

    return data;
  }

  // 상점 / 벌점 수정 modal show
  udfShowRuleInfoaAlert = (data) => {
    let cflag = true;

    if (data === null) {
      const today = new Date();
      data = {
        POINT_GU: '',
        RL_DATE: today.getFullYear() + '-' + (Number(today.getMonth() + 1) < 10 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1)) + '-' + (Number(today.getDate()) < 10 ? '0' + today.getDate() : today.getDate()),
        RL_TIME: '',
        RL_DESC: '',
        ESNTL_NM: this.state.teacherInfo.name,
        ESNTL_ID: this.state.teacherInfo.uniqId,
        POINT: '',
        MSG_CNT: 0,
        CL_CD: '',
        RL_CD: '',
        CL_GU: '',
        RL_SEQ: 0,
      };
    } else {
      // 권한 체크
      if (data.CL_GU === 'B' && (this.state.teacherInfo.ESNTL_GU === 'T' && this.state.teacherInfo.BP_U_YN !== 'Y')) {
        openAlert(this, this.state.usrInfo.BLUE_NM + ' 수정' + noAuthMsg);
        cflag = false;
        return false;
      }

      if (data.CL_GU === 'R' && (this.state.teacherInfo.ESNTL_GU === 'T' && this.state.teacherInfo.RP_U_YN !== 'Y')) {
        openAlert(this, this.state.usrInfo.RED_NM + ' 수정' + noAuthMsg);
        cflag = false;
        return false;
      }

      if (data.CL_GU === 'S') {
        openAlert(this, '지도차감 수정은 웹사이트를 이용해주세요.');
        cflag = false;
        return false;
      }
    }

    if (cflag) {
      this.setState({
        ruleInfo: data
      });
    }
  }

  render() {
    const setRuleList = this.state.ruleList.map((data, idx) => (
      <div className='pb-0 list-group-item' key={idx}>
        <Link to='/usr/ruleInfo' onClick={(e) => {
          // 권한 체크
          if ((data.CL_GU === 'B' || data.CL_GU === 'G') && (this.state.teacherInfo.ESNTL_GU === 'T' && this.state.teacherInfo.BP_U_YN !== 'Y')) {
            let gu = this.state.usrInfo.BLUE_NM;
            if (data.CL_GU === 'G') gu = '회복';
            openAlert(this, gu + ' 수정' + noAuthMsg);
            e.preventDefault();
            e.stopPropagation();
          }

          if (data.CL_GU === 'R' && (this.state.teacherInfo.ESNTL_GU === 'T' && this.state.teacherInfo.RP_U_YN !== 'Y')) {
            openAlert(this, this.state.usrInfo.RED_NM + ' 수정' + noAuthMsg);
            e.preventDefault();
            e.stopPropagation();
          }

          if (data.CL_GU === 'S') {
            openAlert(this, '지도차감 수정은 웹사이트를 이용해주세요.');
            e.preventDefault();
            e.stopPropagation();
          }

          udfSetRuleInfo(data);
        }}>
          <div
            className='row'
            style={{ lineHeight: '180%', margin: '0 0 15px 0' }}
          >
            <div className='pl-0 col-2'><span className={data.POINT_GU === this.state.usrInfo.BLUE_NM ? 'blue-point' : data.POINT_GU === this.state.usrInfo.RED_NM ? 'red-point' : data.POINT_GU === '회복' ? 'green-point' : data.POINT_GU === '차감' ? 'deduction-point' : ''}>{data.POINT_GU}</span></div>
            <div className='col' style={{ paddingLeft: '0', paddingRight: '0' }}>
              <div className='font-weight-bold'>
                {data.DEL_YN === 'Y'
                  ? <span style={{ color: "red", textDecoration: "line-through" }}> {data.RL_DATE} {data.RL_TIME} 삭제됨 </span>
                  : <>{data.RL_DATE} {data.RL_TIME}</>
                }
                <span style={{ float: 'right' }}>
                  <FontAwesomeIcon icon={faChevronRight} />
                </span>
              </div>
              <div style={{ wordBreak: 'break-all' }}>{data.RL_DESC}</div>
              <div>
                <span style={{ float: 'left' }}>교사: {data.ESNTL_NM}</span>
                {
                  this.state.usrInfo && this.state.usrInfo.RATING_GU !== "Z" ?
                    <span className='font-weight-bold point' style={{ fontSize: '1.1rem' }}>{data.POINT} 점</span>
                    : ''
                }
              </div>
            </div>
          </div>
        </Link>
        <Row>
          {
            data.DEL_YN === 'N' && (data.MSG_PRNT_YN === 'Y' || data.MSG_STDT_YN === 'Y' || data.MSG_CHRG_YN === 'Y') ?
              data.MSG_YN === 'T' ?
                <Col>
                  <Button
                    variant='outline-primary'
                    className="p-2"
                    style={{ width: '100%' }}
                    disabled={true}
                  >메시지 발송 중</Button></Col> :
                <Col>
                  <Button
                    variant='outline-primary'
                    className="p-2"
                    style={{ width: '100%' }}
                    onClick={() => {
                      if (data.DEL_YN === 'Y') {
                        openAlert(this, '[발송불가] 삭제된 건은 발송이 불가능합니다.');
                      } else this.fn_sendMsgStdtRuleAlert(data.RL_DATE, data.RL_SEQ)
                    }}
                  >메시지 발송{`(${data.MSG_CNT})`}</Button></Col>
              : ''
          }
          {
            this.state.teacherInfo.ESNTL_GU !== 'T' || (this.state.teacherInfo.ESNTL_GU === 'T' && (this.state.teacherInfo.BP_U_YN === 'Y' || this.state.teacherInfo.RP_U_YN === 'Y')) ?
              this.state.teacherInfo.ESNTL_GU !== 'T' || (this.state.teacherInfo.ESNTL_GU === 'T' && (((data.CL_GU === 'B' || data.CL_GU === 'G') && this.state.teacherInfo.BP_U_YN === 'Y') || (data.CL_GU === 'R' && this.state.teacherInfo.RP_U_YN === 'Y'))) ?
                data.DEL_YN === 'Y' ?
                  <Col><Button variant='outline-success' className='p-2' style={{ width: '100%' }} onClick={() => this.fn_updateRuleDelYnAlert(data.RL_DATE, data.RL_SEQ, data.MSG_CNT, 'N')}>복구</Button></Col> :
                  <Col><Button variant='outline-danger' className='p-2' style={{ width: '100%' }} onClick={() => this.fn_updateRuleDelYnAlert(data.RL_DATE, data.RL_SEQ, data.MSG_CNT, 'Y')}>삭제</Button></Col>
                : ''
              : ''
          }
        </Row>
      </div>
    ));

    const setSendNoList = this.state.sendNoList.map((data, index) => (
      <option value={data.sendNo} key={index}>{data.title}</option>
    ));

    return (
      <>
        {
          this.state.teacherInfo.ESNTL_GU !== 'T' ||
            (this.state.teacherInfo.ESNTL_GU === 'T' && (this.state.teacherInfo.BP_I_YN === 'Y' || this.state.teacherInfo.RP_I_YN === 'Y')) ?
            <>
              <div className='btn-to-top' onClick={() => $(window).scrollTop(0)}><FontAwesomeIcon icon={faAngleUp} /></div>
              <Link to='/usr/ruleInfo' onClick={() => udfSetRuleInfo(this.udfSetEmptyRuleInfo())}><div className='btn-rule-add'><FontAwesomeIcon icon={faPlusCircle} /></div></Link>
            </> : <div className='btn-to-top-b1' onClick={() => $(window).scrollTop(0)}><FontAwesomeIcon icon={faAngleUp} /></div>
        }

        <div className='wrap-loading'>
          <img src={loader} alt='로딩 이미지' />
        </div>

        {/* header */}
        <Navbar fixed='top' className='title'>
          <div className='goBackBtn'><div style={{ color: '#fff' }}><FontAwesomeIcon icon={faArrowCircleLeft} className='btn-home' /></div></div>
          <div>
            {this.state.stdtInfo.HAKGWA}{this.state.stdtInfo.HAKGWA !== undefined ? ' ' + this.state.stdtInfo.GRADE : this.state.stdtInfo.GRADE}-{this.state.stdtInfo.BAN}-{this.state.stdtInfo.BUN} {this.state.stdtInfo.STD_NM}
          </div>
          <SideMenuCmp
            history={this.props.history}
            usrInfo={this.state.usrInfo}
            alertShow={this.state.alertShow}
            alertMessage={this.state.alertMessage}
            alertClickOk={this.state.alertClickOk}
            alertClickYes={this.state.alertClickYes}
            alertClickNo={this.state.alertClickNo}
          />
        </Navbar>

        <div className='container-fluid' style={{ padding: '0', marginBottom: '7rem' }}>
          <ListGroup variant='flush' style={{ marginTop: '55px' }}>
            <ListGroup.Item>
              <Row>
                <Col className='text-nowrap'>
                  {
                    this.state.stdtInfo.HP_STD !== ''
                      && this.state.usrInfo && (this.state.usrInfo.MSG_GRANT || (this.state.teacherInfo.ESNTL_GU === 'T' &&
                        this.state.stdtInfo.HAKGWA === this.state.teacherInfo.HAKGWA &&
                        this.state.stdtInfo.GRADE === this.state.teacherInfo.GRADE &&
                        this.state.stdtInfo.BAN === this.state.teacherInfo.BAN)) ?
                      <a href={`tel:${this.state.stdtInfo.HP_STD}`} className='mr-2' ><FontAwesomeIcon icon={faPhone} /> 학생</a>
                      : ''
                  }
                </Col>
                <Col className='text-nowrap'>
                  {
                    this.state.stdtInfo.HP_PRT !== ''
                      && this.state.usrInfo && (this.state.usrInfo.MSG_GRANT || (this.state.teacherInfo.ESNTL_GU === 'T' &&
                        this.state.stdtInfo.HAKGWA === this.state.teacherInfo.HAKGWA &&
                        this.state.stdtInfo.GRADE === this.state.teacherInfo.GRADE &&
                        this.state.stdtInfo.BAN === this.state.teacherInfo.BAN)) ?
                      <a href={`tel:${this.state.stdtInfo.HP_PRT}`} className='mr-2' ><FontAwesomeIcon icon={faPhone} /> 학부모1</a>
                      : ''
                  }
                </Col>
                <Col className='text-nowrap'>
                  {
                    this.state.stdtInfo.HP_PRT2 !== ''
                      && this.state.usrInfo && (this.state.usrInfo.MSG_GRANT || (this.state.teacherInfo.ESNTL_GU === 'T' &&
                        this.state.stdtInfo.HAKGWA === this.state.teacherInfo.HAKGWA &&
                        this.state.stdtInfo.GRADE === this.state.teacherInfo.GRADE &&
                        this.state.stdtInfo.BAN === this.state.teacherInfo.BAN)) ?
                      <a href={`tel:${this.state.stdtInfo.HP_PRT2}`} ><FontAwesomeIcon icon={faPhone} /> 학부모2</a>
                      : ''
                  }
                </Col>
                <Col className='col-2 text-center'>
                  {
                    this.state.teacherInfo.ESNTL_GU !== 'T' ||
                      (this.state.teacherInfo.ESNTL_GU === 'T' &&
                        this.state.stdtInfo.HAKGWA === this.state.teacherInfo.HAKGWA &&
                        this.state.stdtInfo.GRADE === this.state.teacherInfo.GRADE &&
                        this.state.stdtInfo.BAN === this.state.teacherInfo.BAN) ?
                      <Link to={`/usr/stdtInfo`}>
                        <Badge
                          variant='success'
                          style={{
                            padding: '10px',
                            fontSize: '100%',
                            float: 'right'
                          }}
                        ><FontAwesomeIcon icon={faPen} /></Badge></Link> : ''
                  }
                </Col>
              </Row>
            </ListGroup.Item>
            <ListGroup.Item className='no-padding' style={{ borderBottom: 'none', borderTop: 'none' }}>
              <ButtonToolbar>
                <ToggleButtonGroup type='radio' name='options1' defaultValue={['RULE']} style={{ width: '100%' }} >
                  <ToggleButton variant='light' className='col' value={'RULE'} style={{ borderRadius: '0' }}>{this.state.usrInfo ? this.state.usrInfo.BLUE_NM : '상점'}/{this.state.usrInfo ? this.state.usrInfo.RED_NM : ' 벌점'}</ToggleButton>
                  <ToggleButton variant='light' className='col' value={'CNSL'} style={{ borderRadius: '0' }} onClick={() => {
                    this.props.history.push(`/usr/stdtCnslHistory/${this.state.stdtInfo.STD_CD}`)
                  }}>
                    지도/상담
                  </ToggleButton>
                </ToggleButtonGroup>
              </ButtonToolbar>
            </ListGroup.Item>
            <ListGroup.Item style={{ fontSize: '.9rem', borderTop: 'none' }}>
              부여된 권한: <span className="text-danger">{this.state.teacherInfo.auth_yn}</span>
            </ListGroup.Item>
            {
              this.state.usrInfo && this.state.usrInfo.RATING_GU !== "Z" ?
                <>
                  <ListGroup.Item className='stdtInfoTitle p-2'>{this.state.RATING_GU_NM} = 평점 <span className='font-weight-bold' style={{ fontSize: '1.1rem' }}>{this.state.ratingResult.POINT_RATING}</span></ListGroup.Item>
                  <ListGroup.Item style={{ borderTop: 'none' }}>
                    <Row>
                      <Col className='text-center'>이월 <span className='font-weight-bold' style={{ fontSize: '1.1rem' }}>{this.state.ratingResult.PREV_POINT}</span></Col>
                      <Col className='text-center text-primary'>{this.state.usrInfo ? this.state.usrInfo.BLUE_NM : '상점'} <span className='font-weight-bold' style={{ fontSize: '1.1rem' }}>{this.state.ratingResult.POINT_B}</span></Col>
                      <Col className='text-center text-danger'>{this.state.usrInfo ? this.state.usrInfo.RED_NM : ' 벌점'} <span className='font-weight-bold' style={{ fontSize: '1.1rem' }}>{this.state.ratingResult.POINT_R}</span></Col>
                      <Col className='text-center text-success'>회복 <span className='font-weight-bold' style={{ fontSize: '1.1rem' }}>{this.state.ratingResult.POINT_G}</span></Col>
                      <Col className='text-center'>차감 <span className='font-weight-bold' style={{ fontSize: '1.1rem' }}>{this.state.ratingResult.POINT_S}</span></Col>
                    </Row>
                  </ListGroup.Item>
                </>
                : ''
            }
            {
              this.state.COIN > 0 ?
                <><ListGroup.Item className='p-2 stdtInfoTitle font-weight-bold'>발신번호</ListGroup.Item>
                  <ListGroup.Item style={{ borderTop: 'none' }}>
                    <Form.Control
                      as='select'
                      aria-describedby='SEND_NO'
                      name='SEND_NO'
                      value={this.state.SEND_NO}
                      onChange={(e) => { this.setState({ SEND_NO: e.target.value }) }}
                    >
                      {setSendNoList}
                    </Form.Control>
                  </ListGroup.Item></> : null
            }
            <ListGroup.Item className='stdtInfoTitle font-weight-bold'>
              {this.state.usrInfo ? this.state.usrInfo.BLUE_NM : '상점'}/{this.state.usrInfo ? this.state.usrInfo.RED_NM : ' 벌점'} 현황
            </ListGroup.Item>
            {setRuleList}
          </ListGroup>
        </div>
      </>
    );
  }
}

export default StdtRuleHistoryCmp;